<template>
  <div class="c-login">
    <v-row no-gutters justify="center">
      <v-col cols="auto">
        <img class="text-center c-login__logo" src="@/assets/logo_big.png"/>
      </v-col>
    </v-row>

    <v-row no-gutters justify="center">
      <v-col cols="auto">
        <v-card class="c-login__form">
          <v-container>
            <v-row>
              <v-col cols="auto">
                <ValidationObserver ref="observer" v-slot="{ invalid }" @keyup.native.enter="submit">
                  <ValidationProvider name="identifiant" rules="required" v-slot="{ errors }">
                    <v-text-field
                      label="Identifiant"
                      v-model="username"
                      :error-messages="errors[0]"
                    >
                      <v-icon slot="prepend" color="red">perm_identity</v-icon>
                    </v-text-field>
                  </ValidationProvider>

                  <ValidationProvider name="mot de passe" rules="required" v-slot="{ errors }">
                    <v-text-field
                      label="Mot de passe"
                      v-model="password"
                      type="password"
                      :error-messages="errors[0]"
                    >
                      <v-icon slot="prepend" color="red">lock</v-icon>
                    </v-text-field>
                  </ValidationProvider>

                  <v-alert :value="!!error" type="error">
                    {{ error }}
                  </v-alert>

                  <div class="text-center">
                    <v-btn class="text-center"
                      color="success"
                      :disabled="invalid || pending"
                      @click="submit"
                    >
                      login
                    </v-btn>

                    <v-progress-linear :indeterminate="true" v-if="pending"></v-progress-linear>
                  </div>
                </ValidationObserver>
              </v-col>
            </v-row>
          </v-container>
        </v-card>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import { AUTH_LOGIN } from '@/store/actions/auth';
import { mapActions } from 'vuex';


export default {
  name: 'LogIn',

  data: () => ({
    pending: false,
    error: null,

    username: '',
    password: ''
  }),
  methods: {
    ...mapActions([AUTH_LOGIN]),

    async submit () {
      const isValid = await this.$refs.observer.validate();
      if (!isValid) {
        return;
      }

      this.error = null;
      this.pending = true;

      try {
        await this.AUTH_LOGIN({
          username: this.username,
          password: this.password
        });

        this.$router.push('/');
      } catch (err) {
        switch (err.response.status) {
          case 401:
            this.error = 'Mauvais identifiant/mot de passe';
            break;

          default:
            this.$log.error(err);
            this.error = err.message;
            break;
        }
      }

      this.pending = false;
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.c-login {
  &__logo {
    margin: 100px 0 100px 0;
    height: 120px;
  }

  &__form {
    padding: 20px;
    background-color: rgba(255, 255, 255, 0.116);
    border: solid 1px white;
  }
}
</style>
